export default {
  namespaced: true,
  state: {
    message: '',
    modalData: [],
    showGreeting: false,
    isError: false,
    popupComplete: false,
  },
  mutations: {
    setMessage(state, message) {
      state.message = message
    },
    setModalData(state, modalData) {
      state.modalData = modalData
    },
    setIsError(state, IsError) {
      state.isError = IsError
    },
    setShowGreeting(state, flag) {
      state.showGreeting = flag
    },
    setPopupComplete(state, flag) {
      state.popupComplete = flag
    },
  },
  getters: {
    showMessage: (state) => state.message,
    modalData: (state) => state.modalData,
    showGreeting: (state) => state.showGreeting,
    showError: (state) => state.isError,
    popupComplete: (state) => state.popupComplete,
  },
  actions: {
    onMessage({ commit }, data) {
      commit('setMessage', data.message)
      commit('setShowGreeting', true)
      commit('setIsError', data.IsError)
      commit('setModalData', data.modalData || {title: '', data: []})
      data.complete ? commit('setPopupComplete', data.complete) : commit('setPopupComplete', false)
      setTimeout(function () {
        commit('setShowGreeting', false)
        commit('setModalData', {title: '', data: []})
      }, data.duration || 3000)
    },
  },
}
